<template>
  <div>
    <b-card border-variant="dark" class="mt-4">
      <div class="height-queue">
        <div id="queue-header">
          <span class="font-weight-bold font-15" style="flex: 1">Em atendimento</span>
          <input type="text" class="form-control ml-2" v-model="searchTerm" placeholder="Pesquisar cliente..." style="flex: 2" />
          <select class="form-control ml-2" v-model="attFilter" style="flex: 1">
            <option value="*">Todos</option>
            <option value="ativo">Atendimentos Ativos</option>
            <option value="receptivo">Atendimentos Receptivos</option>
          </select>
        </div>

        <b-table
          id="queue"
          small
          striped
          bordered
          fixed
          :per-page="perPage"
          :fields="fields"
          :items="filteredItems"
          responsive="sm"
          class="mt-2"
          :current-page="currentPage"
          show-empty
        >
          <template #empty>
            <h6 class="text-center">Nenhum cliente em atendimento</h6>
          </template>

          <template #cell(time)="data">
            <b-badge :variant="getTime(data.item.time).variant">{{ getTime(data.item.time).val }}</b-badge>
          </template>

          <template #cell(queue)="data">
            <span :class="data.item.queue === 'Ativo' ? 'text-danger font-weight-bold' : ''">{{ data.item.queue }}</span>
          </template>

          <template #cell(opcao)="data">
            <i id="action-button-view" class="image-button fa fa-eye" @click.prevent="abrirVisualizar(data.item.opcao)"></i>
            <i id="action-button-invite" class="image-button fa fa-reply" @click="openModalTransf(data.item.opcao)"></i>
            <i id="action-button-delete" class="image-button fas fa-trash" @click.prevent="limparUra(data.item.opcao)"></i>
          </template>
        </b-table>

        <b-pagination
          v-model="currentPage"
          pills
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="queue"
          size="sm"
          align="right"
        />
      </div>
    </b-card>

    <dtModalVisualizar ref="dtModalVisualizar" />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
const socket = require('./../../../modules/realtime/service/service');
const meuAvatar = '/imgs/icons/person.svg';

export default {
  name: 'TbFilaAndamento',
  data: () => ({
    fields: [
      { key: 'operator', label: 'Operador', class: 'text-center align-middle', thStyle: { 'font-weight': 'bold' } },
      { key: 'queue', label: 'Fila', class: 'text-center align-middle', thStyle: { 'font-weight': 'bold' } },
      { key: 'nome', label: 'Cliente', class: 'text-center align-middle', thStyle: { 'font-weight': 'bold' } },
      { key: 'fone', label: 'Telefone', class: 'text-center align-middle', thStyle: { width: '160px', 'font-weight': 'bold' } },
      { key: 'time', label: 'Tempo', class: 'text-center align-middle', thStyle: { width: '70px', 'font-weight': 'bold' } },
      { key: 'opcao', label: 'Ações', class: 'text-center align-middle', thStyle: { width: '120px', 'font-weight': 'bold' } }
    ],
    currentPage: 1,
    perPage: 10,
    queues: [],
    userChatQueues: [],
    users: [],
    attFilter: '*',
    items: [],
    searchTerm: '',
    dadoClient: null
  }),
  created() {
    axios.get('/user-chat-queues').then(({ data }) => {
      this.userChatQueues = data || [];
      this.userChatQueues.push('entrante');
    });
    axios.get('/realtime/listUsers').then(({ data }) => {
      this.users = data || [];
    });
    socket.connection.on('queueAttend', (obj) => {
      this.queues = obj.queues || [];
      this.getItems();
    });
  },
  computed: {
    ...mapGetters(['getUserRealtime']),
    rows() {
      return this.filteredItems.length;
    },
    filteredItems() {
      let data = this.items;
      if (this.attFilter === 'receptivo') data = data.filter((v) => v.__tipo === 'receptivo');
      else if (this.attFilter === 'ativo') data = data.filter((v) => v.__tipo === 'ativo');
      if (this.searchTerm) {
        const k = this.searchTerm.toLowerCase();
        data = data.filter((el) =>
          String(el.fone || '').toLowerCase().includes(k) ||
          String(el.nome || '').toLowerCase().includes(k) ||
          String(el.operator || '').toLowerCase().includes(k) ||
          String(el.queue || '').toLowerCase().includes(k)
        );
      }
      return data;
    }
  },
  methods: {
    ...mapMutations(['setUserRealtime', 'setUserRealtimeData']),
    ...mapActions(['transferOptions']),
    async abrirVisualizar(idUsers) {
      await this.setUserRealtime(idUsers);
      if (this.getUserRealtime) {
        await socket.connection.emit('newEntryRealtimeUsers', { idUsers });
        this.$refs.dtModalVisualizar.openModal();
      }
    },
    openModalTransf(dado) {
      this.dadoClient = dado;
      this.$emit('open-modal-transf', dado);
    },
    getItems() {
      this.items = this.mountTable();
    },
    getTime(time) {
      if (isNaN(time)) return { val: '00:00:00', variant: 'success' };
      let horas = ('00' + parseInt(time / 3600)).slice(-2);
      time = time - horas * 3600;
      let minutos = ('00' + parseInt(time / 60)).slice(-2);
      time = time - minutos * 60;
      let segundos = ('00' + parseInt(time)).slice(-2);
      const format = `${horas}:${minutos}:${segundos}`;
      if (+horas < 1 && +minutos < 30) return { val: format, variant: 'success' };
      if (+horas < 3) return { val: format, variant: 'warning' };
      return { val: format, variant: 'danger' };
    },
    formTelefone(tel) {
      if (!tel || typeof tel !== 'string') return '';
      if (tel.includes('@')) tel = tel.split('@')[0];
      if (tel.substr(0, 2) !== '55') return '+' + tel;
      if (tel.length === 10 || tel.length === 11) {
        const v1 = tel.replace(/\D/g, '');
        const v2 = v1.replace(/^(\d{2})(\d)/g, '($1) $2');
        const v3 = v2.replace(/(\d)(\d{4})$/, '$1-$2');
        return v3;
      }
      tel = tel.replace(/\D/g, '');
      tel = tel.replace(/^(\d)/, '+$1');
      tel = tel.replace(/(.{3})(\d)/, '$1($2');
      tel = tel.replace(/(.{6})(\d)/, '$1)$2');
      if (tel.length === 12) tel = tel.replace(/(.{1})$/, '-$1');
      else if (tel.length === 13) tel = tel.replace(/(.{2})$/, '-$1');
      else if (tel.length === 14) tel = tel.replace(/(.{3})$/, '-$1');
      else if (tel.length === 15) tel = tel.replace(/(.{4})$/, '-$1');
      else if (tel.length > 15) tel = tel.replace(/(.{4})$/, '-$1');
      tel = tel.replace('(', ' (');
      tel = tel.replace(')', ') ');
      return tel;
    },
    limparUra(client) {
      const arrayDados = { client, operador: new User().getId() };
      Swal.fire({
        title: 'Remover do Atendimento?',
        text: `Você tem certeza que deseja remover este cliente ${this.formTelefone(client)} do atendimento?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: 'rgb(28,134,154)',
        confirmButtonText: 'Sim, remover',
        cancelButtonText: 'Cancelar'
      }).then((isConfirm) => {
        if (isConfirm.value) socket.connection.emit('queueUraDelete', { arrayDados });
      });
    },
    mountTable() {
      const now = moment().format('YYYY-MM-DD HH:mm:ss');
      const allowed = new Set((this.userChatQueues || []).map((v) => String(v).toLowerCase()));
      const normalizeTipo = (q) => {
        const raw = String(q || '').trim().toLowerCase();
        if (raw === 'entrante' || raw === 'ativo' || raw.includes('ativo')) return { label: 'Ativo', tipo: 'ativo' };
        return { label: q || '', tipo: 'receptivo' };
      };
      const out = [];
      (this.queues || []).forEach((q) => {
        const name = String(q.queue || '').toLowerCase();
        if (allowed.size && !allowed.has(name)) return;
        const ms = moment(now).diff(moment(q.created_at || q.time || new Date()));
        const userOperator = this.users.find((o) => String(o.id) === String(q.operator) || String(o.extension_line) === String(q.operator));
        const tipo = normalizeTipo(q.queue);
        out.push({
          operator: userOperator ? userOperator.nome : q.operator,
          fone: this.formTelefone(String(q.client_id || q.client || '')),
          nome: q.client || q.cName || '',
          queue: tipo.label,
          time: isNaN(ms) ? 0 : moment.duration(ms).asSeconds(),
          opcao: q.client_id,
          __tipo: tipo.tipo
        });
      });
      out.sort((a, b) => Number(a.time) - Number(b.time));
      return out;
    }
  },
  watch: {
    queues() {
      this.getItems();
      this.transferOptions();
    },
    attFilter() {
      this.getItems();
    }
  }
};
</script>

<style scoped>
#queue-header { display: flex; justify-content: space-between; }
.card { color: black !important; border: 1px solid rgba(0,0,0,0.125) !important; border-radius: 0.25rem !important; }
.font-15 { font-size: 15px; }
#action-button-view { cursor: pointer; font-size: 16px; color: #1c869a; transition: .25s; margin: 5px; }
#action-button-view:hover { color: #177081; }
#action-button-invite { cursor: pointer; font-size: 16px; color: black; transition: .25s; margin: 5px; }
#action-button-invite:hover { color: #424242; }
#action-button-delete { cursor: pointer; font-size: 16px; color: #e3342f; transition: .25s; margin: 5px; }
#action-button-delete:hover { color: #b42a26; }
</style>
